// extracted by mini-css-extract-plugin
module.exports =  {"scrollControls":"scrollControls_PdFvnqf_","disabled":"disabled_oAPclU6Z","arrowScrollContainer":"arrowScrollContainer_GmqQStS6"};